/* unplugin-vue-components disabled */import script from "./WxInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./WxInfo.vue?vue&type=script&setup=true&lang=js"

import "./WxInfo.vue?vue&type=style&index=0&id=0b0a7486&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b0a7486"]])

export default __exports__